(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demo"] && !Shopify.designMode) return;
  try {
    
  class CuratedLooksSlider extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.isAnimating = false;
      this.autoplayTimer = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-cl-track]');
      this.slides = Array.from(this.querySelectorAll('[data-cl-slide]'));
      this.prevBtn = this.querySelector('[data-cl-prev]');
      this.nextBtn = this.querySelector('[data-cl-next]');
      this.dots = Array.from(this.querySelectorAll('[data-cl-dot]'));

      if (this.slides.length === 0) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.activeIndex = Math.floor(this.slides.length / 2);

      this.update();
      this.bindEvents();

      if (this.autoplay && this.slides.length > 1) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    update() {
      const total = this.slides.length;
      this.slides.forEach((slide, i) => {
        let offset = i - this.activeIndex;
        if (offset > total / 2) offset -= total;
        if (offset < -total / 2) offset += total;
        slide.dataset.offset = offset;
        slide.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
        const link = slide.querySelector('.curated-looks__card');
        if (link) link.setAttribute('tabindex', offset === 0 ? '0' : '-1');
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.activeIndex);
        dot.setAttribute('aria-selected', i === this.activeIndex ? 'true' : 'false');
      });
    }

    goTo(index) {
      if (this.isAnimating) return;
      const total = this.slides.length;
      this.isAnimating = true;
      this.activeIndex = ((index % total) + total) % total;
      this.update();
      setTimeout(() => { this.isAnimating = false; }, 700);
    }

    next() { this.goTo(this.activeIndex + 1); }
    prev() { this.goTo(this.activeIndex - 1); }

    bindEvents() {
      this.prevBtn && this.prevBtn.addEventListener('click', () => {
        this.prev();
        this.resetAutoplay();
      });

      this.nextBtn && this.nextBtn.addEventListener('click', () => {
        this.next();
        this.resetAutoplay();
      });

      this.slides.forEach((slide, i) => {
        slide.addEventListener('click', (e) => {
          if (i === this.activeIndex) return;
          e.preventDefault();
          this.goTo(i);
          this.resetAutoplay();
        });
      });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.goTo(i);
          this.resetAutoplay();
        });
      });

      // Touch / swipe
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        this.stopAutoplay();
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const dx = Math.abs(e.touches[0].clientX - startX);
        const dy = Math.abs(e.touches[0].clientY - startY);
        if (dx > dy && dx > 10) {
          // horizontal swipe takes over
        }
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
        this.resetAutoplay();
      }, { passive: true });

      // Keyboard
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prev();
          this.resetAutoplay();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.next();
          this.resetAutoplay();
        }
      });

      // Pause on hover / focus
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      // Pause when off-screen
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.startAutoplay();
            else this.stopAutoplay();
          });
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('curated-looks-slider')) {
    customElements.define('curated-looks-slider', CuratedLooksSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleair-autowrap"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-autowrap')) {
    customElements.define('sa-autowrap', class extends HTMLElement {
      connectedCallback() {
        const btns = [...this.querySelectorAll('[data-barrel]')];
        const lbl = this.querySelector('.sa-wrapx__lbl');
        btns.forEach((b) => b.addEventListener('click', () => {
          const dir = b.dataset.barrel;
          btns.forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
          this.dataset.dir = dir;
          if (lbl) lbl.textContent = (lbl.dataset[dir] || '').replace(/\\n/g, '\n');
        }));
        if (lbl) lbl.textContent = (lbl.dataset.left || '').replace(/\\n/g, '\n');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleair-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-drawer')) {
    customElements.define('sa-drawer', class extends HTMLElement {
      connectedCallback() {
        const list = this.querySelector('[data-sa-drawer-list]');
        const on = () => this.classList.add('is-in');
        if (!list || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { on(); return; }
        this.io = new IntersectionObserver((es) => { if (es[0].isIntersecting) { on(); this.io.disconnect(); } }, { threshold: 0.35 });
        this.io.observe(list);
      }
      disconnectedCallback() { this.io && this.io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleair-looks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-looks')) {
    customElements.define('sa-looks', class extends HTMLElement {
      connectedCallback() {
        this.btns = [...this.querySelectorAll('.sa-looks__btn')];
        this.imgs = [...this.querySelectorAll('.sa-looks__img')];
        this.panels = [...this.querySelectorAll('.sa-looks__panel')];
        this.btns.forEach((b, i) => b.addEventListener('click', () => this.select(i)));
        this.onJump = (e) => this.select(e.detail.index);
        document.addEventListener('styleair:look', this.onJump);
        this.onBlock = (e) => { const i = this.btns.findIndex((b) => b.contains(e.target)); if (i > -1) this.select(i); };
        document.addEventListener('shopify:block:select', this.onBlock);
      }
      disconnectedCallback() {
        document.removeEventListener('styleair:look', this.onJump);
        document.removeEventListener('shopify:block:select', this.onBlock);
      }
      select(i) {
        if (i < 0 || i >= this.btns.length) return;
        this.btns.forEach((b, k) => { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i); });
        this.imgs.forEach((m, k) => { m.classList.toggle('is-on', k === i); k === i ? m.removeAttribute('aria-hidden') : m.setAttribute('aria-hidden', 'true'); });
        this.panels.forEach((p, k) => { p.hidden = k !== i; });
        const b = this.btns[i], list = b.parentElement;
        if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: b.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleair-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-set')) {
    customElements.define('sa-set', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.sa-set__item')];
        this.dots = [...this.querySelectorAll('.sa-set__dot')];
        const bind = (el) => {
          const i = +el.dataset.i;
          ['click', 'mouseenter', 'focus'].forEach((ev) => el.addEventListener(ev, () => this.select(i)));
        };
        this.items.forEach(bind);
        this.dots.forEach(bind);
        this.onBlock = (e) => { const i = this.items.findIndex((b) => e.target.contains(b)); if (i > -1) this.select(i); };
        document.addEventListener('shopify:block:select', this.onBlock);
      }
      disconnectedCallback() { document.removeEventListener('shopify:block:select', this.onBlock); }
      select(i) {
        if (i === this.cur) return;
        this.cur = i;
        this.items.forEach((b, k) => { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i); });
        this.dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleair-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-sticky')) {
    customElements.define(
      'sa-sticky',
      class extends HTMLElement {
        connectedCallback() {
          // Move to <body> so a transformed theme wrapper can't break position:fixed.
          if (this.parentElement !== document.body) {
            document.querySelectorAll('body > sa-sticky').forEach((el) => el.remove());
            document.body.appendChild(this);
            return;
          }
          this.onUnload = (e) => {
            if (e.detail && e.detail.sectionId === this.dataset.section) this.remove();
          };
          document.addEventListener('shopify:section:unload', this.onUnload);
          this.bar = this.querySelector('[data-sa-bar]');
          this.eyebrow = this.querySelector('[data-sa-eyebrow]');
          this.rail = this.querySelector('[data-sa-rail]');
          this.sections = [...document.querySelectorAll('.sa[data-sa-label][id]')].filter((el) =>
            el.dataset.saLabel.trim()
          );
          if (!('IntersectionObserver' in window)) return;
          if (this.bar) {
            if (this.dataset.reserve === 'true') document.body.classList.add('sa-has-sticky');
            const hides = [...document.querySelectorAll('[data-sa-hide-sticky]')];
            const vis = new Map();
            const update = () => {
              const on = hides.length ? ![...vis.values()].some(Boolean) : scrollY > innerHeight;
              this.bar.classList.toggle('is-on', on);
              this.bar.setAttribute('aria-hidden', !on);
              this.bar.querySelectorAll('a,button').forEach((el) => (el.tabIndex = on ? 0 : -1));
              document.body.classList.toggle('sa-sticky-on', on);
            };
            hides.forEach((el) => vis.set(el, true));
            this.ho = new IntersectionObserver((es) => {
              es.forEach((e) => vis.set(e.target, e.isIntersecting));
              update();
            });
            hides.forEach((el) => this.ho.observe(el));
            if (!hides.length) {
              this.onScroll = update;
              addEventListener('scroll', update, { passive: true });
            }
          }
          if (this.rail) {
            this.rail.innerHTML = this.sections
              .map(
                (el, i) =>
                  `<a href="#${el.id}" aria-current="false"><i></i><span>${String(i + 1).padStart(
                    2,
                    '0'
                  )}</span><b></b></a>`
              )
              .join('');
            [...this.rail.children].forEach((a, i) => {
              a.querySelector('b').textContent = this.sections[i].dataset.saLabel;
            });
          }
          this.so = new IntersectionObserver(
            (es) =>
              es.forEach((e) => {
                if (e.isIntersecting) this.setActive(this.sections.indexOf(e.target));
              }),
            { rootMargin: '-45% 0px -50% 0px' }
          );
          this.sections.forEach((el) => this.so.observe(el));
          this.setActive(0);
        }
        setActive(i) {
          if (i < 0) return;
          if (this.rail) [...this.rail.children].forEach((a, k) => a.setAttribute('aria-current', k === i));
          if (this.eyebrow) {
            const wide = matchMedia('(min-width: 960px)').matches;
            const el = this.sections[i];
            this.eyebrow.textContent =
              wide || !el ? this.eyebrow.dataset.desktop : `${String(i + 1).padStart(2, '0')} · ${el.dataset.saLabel}`;
          }
        }
        disconnectedCallback() {
          this.ho && this.ho.disconnect();
          this.so && this.so.disconnect();
          this.onScroll && removeEventListener('scroll', this.onScroll);
          this.onUnload && document.removeEventListener('shopify:section:unload', this.onUnload);
          document.body.classList.remove('sa-has-sticky', 'sa-sticky-on');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleair-turn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-turn')) {
    customElements.define('sa-turn', class extends HTMLElement {
      connectedCallback() {
        this.turned = false;
        this.deg = 0;
        this.degEl = this.querySelector('[data-sa-deg]');
        this.cap = this.querySelector('[data-sa-turn-cap]');
        this.dial = this.querySelector('[data-sa-toggle]');
        this.segs = [...this.querySelectorAll('[data-sa-set]')];
        this.dial.addEventListener('click', () => this.set(!this.turned));
        this.segs.forEach((b) => b.addEventListener('click', () => this.set(b.dataset.saSet === '1')));
      }
      set(t) {
        if (t === this.turned) return;
        this.turned = t;
        this.classList.toggle('is-turned', t);
        this.segs.forEach((b) => { const on = (b.dataset.saSet === '1') === t; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
        this.cap.textContent = t ? this.dataset.capB : this.dataset.capA;
        this.dial.setAttribute('aria-label', t ? this.dataset.ariaB : this.dataset.ariaA);
        const [a, b] = this.querySelectorAll('.sa-turn__img');
        a.toggleAttribute('aria-hidden', t);
        b.toggleAttribute('aria-hidden', !t);
        this.animate(t ? 90 : 0);
      }
      animate(to) {
        cancelAnimationFrame(this.raf);
        if (window.StyleAir && StyleAir.reduced) { this.deg = to; this.degEl.textContent = to; return; }
        const from = this.deg, t0 = performance.now(), D = 950;
        const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
        const step = (now) => {
          const p = Math.min(1, (now - t0) / D);
          this.deg = Math.round(from + (to - from) * ease(p));
          this.degEl.textContent = this.deg;
          if (p < 1) this.raf = requestAnimationFrame(step);
        };
        this.raf = requestAnimationFrame(step);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
